import { createContext, useContext } from "react";
import type { ChartSettings } from "./types";

/** What the server returns before anything has been saved. */
export const DEFAULT_CHART_SETTINGS: ChartSettings = {
  timeframe: "daily",
  tradingview_layout: null,
  moving_averages: [
    { period: 10, kind: "ema", enabled: true },
    { period: 20, kind: "ema", enabled: true },
    { period: 50, kind: "ema", enabled: true },
  ],
};

export const ChartSettingsContext = createContext<{
  settings: ChartSettings;
  save: (next: ChartSettings) => Promise<void>;
}>({ settings: DEFAULT_CHART_SETTINGS, save: async () => {} });

export const useChartSettings = () => useContext(ChartSettingsContext);
